/**
 * Route Constants
 *
 * Single source of truth for all URL paths in the application.
 * Import from here instead of hardcoding strings in components.
 *
 * Usage:
 *   import { ROUTES } from '@shared/config/routes';
 *   navigate(ROUTES.APP.APPROVALS);
 *   navigate(ROUTES.VISITOR.token('abc123'));
 */

// ── Staff app (auth-required) ────────────────────────────────────────────────
const APP_BASE = '/app';

const APP = {
  // Root — redirects to HOME
  ROOT:             `${APP_BASE}`,

  // Core
  HOME:             `${APP_BASE}/home`,
  DASHBOARD:        `${APP_BASE}/dashboard`,
  ANALYTICS:        `${APP_BASE}/analytics`,
  PROJECTS:         `${APP_BASE}/projects`,

  // Operations
  ROLL_CALL:        `${APP_BASE}/roll-call`,
  KIOSK:            `${APP_BASE}/kiosk`,
  INCIDENTS:        `${APP_BASE}/incidents`,

  // Induction
  APPROVALS:        `${APP_BASE}/approvals`,
  VISITORS:         `${APP_BASE}/visitors`,
  INDUCTION_BRIEFS: `${APP_BASE}/induction-briefs`,
  QR_CODES:         `${APP_BASE}/qr-codes`,

  // Auditing
  AUDIT_HUB:        `${APP_BASE}/audit-hub`,
  AUDITS:           `${APP_BASE}/audits`,
  TEMPLATES:        `${APP_BASE}/templates`,

  // Admin / Settings
  DEPOTS:           `${APP_BASE}/depots`,
  SYSTEM_SETTINGS:  `${APP_BASE}/system-settings`,
  USER_MANAGEMENT:  `${APP_BASE}/user-management`,
  REPORTS:          `${APP_BASE}/reports`,
  LOCATIONS:        `${APP_BASE}/locations`,
  NOTIFICATIONS:    `${APP_BASE}/notifications`,
  ACCOUNT_SECURITY: `${APP_BASE}/account-security`,
  SUBSCRIPTION:     `${APP_BASE}/subscription`,
};

// ── Auth ─────────────────────────────────────────────────────────────────────
const AUTH = {
  LOGIN:           '/login',
  RESET_PASSWORD:  '/reset-password',
  CHANGE_PASSWORD: '/change-password',
};

// ── Visitor induction (public, no auth) ─────────────────────────────────────
const VISITOR_BASE = '/i';

const VISITOR = {
  ROOT:  VISITOR_BASE,
  /** @param {string} token */
  token: (token) => `${VISITOR_BASE}/${token}`,
};

// ── Supplier portal (portal auth) ───────────────────────────────────────────
const PORTAL_BASE = '/portal';

const PORTAL = {
  ROOT: PORTAL_BASE,
};

// ── Exports ──────────────────────────────────────────────────────────────────
export const ROUTES = {
  APP,
  AUTH,
  VISITOR,
  PORTAL,
};
